import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomPreloadingStrategy } from './core/utils/preloading-strategy';
import { PagesComponent } from './pages/pages.component';
import { UserAuthGuard } from './auth-guard/user-auth.guard';
import { UserAuthStateGuard } from './auth-guard/user-auth-state.guard';
import { ResetPasswordModule } from './pages/reset-password/reset-password.module';

const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./pages/user/login/login.module').then((m) => m.LoginModule),
        canActivate: [UserAuthStateGuard],
      },

      {
        path: 'registration',
        loadChildren: () =>
          import('./pages/user/registration/registration.module').then(
            (m) => m.RegistrationModule
          ),
        canActivate: [UserAuthStateGuard],
      },
      {
        path: 'complete-registration',
        loadChildren: () =>
          import(
            './pages/complete-registration/complete-registration.module'
          ).then((m) => m.CompleteRegistrationModule),
      },
      {
        path: 'product-list',
        loadChildren: () =>
          import('./pages/product-list/product-list.module').then(
            (m) => m.ProductListModule
          ),
      },
      {
        path: 'products/details',
        loadChildren: () =>
          import('./pages/product-details/product-details.module').then(
            (m) => m.ProductDetailsModule
          ),
      },
      {
        path: 'cart',
        loadChildren: () =>
          import('./pages/cart/cart.module').then((m) => m.CartModule),
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./pages/payment-status/payment-status.module').then(
            (m) => m.PaymentStatusModule
          ),
      },
      {
        path: 'pharmacy',
        loadChildren: () =>
          import('./pages/pharmacy/pharmacy.module').then(
            (m) => m.PharmacyModule
          ),
      },
      {
        path: 'checkout',
        loadChildren: () =>
          import('./pages/checkout/checkout.module').then(
            (m) => m.CheckoutModule
          ),
        canActivate: [UserAuthGuard],
      },
      {
        path: 'confirmation',
        loadChildren: () =>
          import('./pages/order-confirmation/order-confirmation.module').then(
            (m) => m.OrderConfirmationModule
          ),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./pages/account/account.module').then((m) => m.AccountModule),
        canActivate: [UserAuthGuard],
        data: { preload: true, delay: 20 },
      },
      {
        path: 'notice-details/:id',
        loadChildren: () =>
          import(
            './pages/notification-details/notification-details.module'
          ).then((m) => m.NotificationDetailsModule),
      },
      {
        path: 'privacy-policy',
        loadChildren: () =>
          import('./pages/privacy-policy/privacy-policy.module').then(
            (m) => m.PrivacyPolicyModule
          ),
      },
      {
        path: 'return-and-refund-policy',
        loadChildren: () =>
          import(
            './pages/return-and-refund-policy/return-and-refund-policy.module'
          ).then((m) => m.ReturnAndRefundPolicyModule),
      },
      {
        path: 'terms-and-conditions',
        loadChildren: () =>
          import(
            './pages/terms-and-conditions/terms-and-conditions-routing.module'
          ).then((m) => m.TermsAndConditionsRoutingModule),
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./pages/category/category.module').then(
            (m) => m.CategoryModule
          ),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import('./pages/contact-us/contact-us.module').then(
            (m) => m.ContactUsModule
          ),
      },
      {
        path: 'about-us',
        loadChildren: () =>
          import('./pages/about-us/about-us.module').then(
            (m) => m.AboutUsModule
          ),
      },
      {
        path: 'job',
        loadChildren: () =>
          import('./pages/carrier/carrier.module').then((m) => m.CarrierModule),
      },
      {
        path: 'job/details',
        loadChildren: () =>
          import('./pages/carrier-details/carrier-details.module').then(
            (m) => m.CarrierDetailsModule
          ),
      },
      {
        path: 'pages',
        loadChildren: () =>
          import(
            './pages/additional-page-view/additional-page-view.module'
          ).then((m) => m.AdditionalPageViewModule),
      },
      {
        path: 'blogs',
        loadChildren: () =>
          import('./pages/all-blogs/all-blogs.module').then(
            (m) => m.AllBlogsModule
          ),
      },
      {
        path: 'coming-soon',
        loadChildren: () =>
          import('./pages/coming-soon/coming-soon.module').then(
            (m) => m.ComingSoonModule
          ),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./pages/reset-password/reset-password.module').then(
            (m) => ResetPasswordModule
          ),
      },
      {
        path: '**',
        loadChildren: () =>
          import('./pages/not-found/not-found.module').then(
            (m) => m.NotFoundModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      preloadingStrategy: CustomPreloadingStrategy,
    }),
  ],
  exports: [RouterModule],
  providers: [UserAuthGuard, UserAuthStateGuard],
})
export class AppRoutingModule {}
